import React, { useState, useEffect } from "react";

const EncuestaSocioambiental = ({ initialData, onSave, onCancel, saveLabel, formDataRef, showUbicarButton = true }) => {
  const [formData, setFormData] = useState(
    initialData || {
      nombreApellido: "",
      nro_beneficiario: "",
      fechaNacimiento: "",
      dni: "",
      telefono: "",
      direccion: "",
      barrio: "",
      localidad: "",
      personasACargo: "",
      aniosEnBarrio: "",
      tipoVivienda: "",
      convivientes: [{ nombre: "", relacion: "", edad: "", estudia: "", trabaja: "" }],
      nivelCriticidad: "",
      estadoGeneral: "",
      breveDescripcionMejora: "",
      prioridades: {
        piso: false, techo: false, paredes: false, revoques: false,
        aislante: false, instalacionGas: false, instalacionAgua: false,
        instalacionLuz: false, instalacionCloacas: false, otros: false,
      },
      calidadDeVidaMejora: "",
      materiales: [
        { descripcion: "", cantidad: "", precio: "" },
        { descripcion: "", cantidad: "", precio: "" },
        { descripcion: "", cantidad: "", precio: "" },
      ],
      manoDeObraPrecio: "",
      otroGastoPrecio: "",
      montoCredito: "",
      formaPago: "",
      nroCuotas: "",
      montoCuotas: "",
      mesInicio: "",
      frecuenciaPago: "",
      garantiaGarantes: "",
    }
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === 'direccion' ? { direccionDesdeMapa: false } : {}),
    }));
  };

  useEffect(() => {
    if (formDataRef) formDataRef.current = formData;
  }, [formData, formDataRef]);

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      prioridades: { ...prev.prioridades, [name]: checked },
    }));
  };

  const handleConvivienteChange = (index, field, value) => {
    const nuevos = [...formData.convivientes];
    nuevos[index] = { ...nuevos[index], [field]: value };
    setFormData((prev) => ({ ...prev, convivientes: nuevos }));
  };

  const agregarConviviente = () => {
    setFormData((prev) => ({
      ...prev,
      convivientes: [...prev.convivientes, { nombre: "", relacion: "", edad: "", estudia: "", trabaja: "" }],
    }));
  };

  const handleMaterialChange = (index, field, value) => {
    const nuevos = [...formData.materiales];
    nuevos[index] = { ...nuevos[index], [field]: value };
    setFormData((prev) => ({ ...prev, materiales: nuevos }));
  };

  const agregarFilaMaterial = () => {
    setFormData((prev) => ({
      ...prev,
      materiales: [...prev.materiales, { descripcion: "", cantidad: "", precio: "" }],
    }));
  };

  const handleUbicar = (e) => { e.preventDefault(); onSave(formData, 'ubicar'); };
  const handleValidar = (e) => { e.preventDefault(); onSave(formData, 'validar'); };

  // Campos obligatorios: N° beneficiario, Nombre y DNI habilitan "Validar y salir"
  const obligatoriosCompletos = Boolean((formData.nro_beneficiario || '').toString().trim()) &&
    Boolean((formData.nombreApellido || '').trim()) &&
    Boolean((formData.dni || '').trim());

  const inputCls = "w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500";
  const labelCls = "block text-xs font-medium text-gray-600 dark:text-gray-300 mb-1";
  const fieldsetCls = "border border-gray-200 dark:border-gray-600 rounded-lg p-4 mb-4";
  const legendCls = "text-sm font-bold text-gray-800 dark:text-gray-100 px-2";
  const btnCls = "px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors";
  const btnSecondaryCls = "px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-gray-200 dark:bg-gray-600 hover:bg-gray-300 dark:hover:bg-gray-500 rounded-md transition-colors";

  return (
    <form onSubmit={handleUbicar} className="p-4 space-y-4 overflow-y-auto max-h-full">
      <h1 className="text-xl font-bold text-gray-900 dark:text-white mb-4">ENCUESTA SOCIOAMBIENTAL</h1>

      <fieldset className={fieldsetCls}>
        <legend className={legendCls}>1. Mis Datos Personales y del Proyecto</legend>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-2">
          <div className="md:col-span-1 max-w-[190px]">
            <label className={labelCls}>N° beneficiario <span className="text-red-500">*</span></label>
            <input type="number" name="nro_beneficiario" value={formData.nro_beneficiario} onChange={handleChange} className={inputCls} />
            {!(formData.nro_beneficiario || '').toString().trim() && <p className="text-sm text-red-600 mt-1 whitespace-nowrap">*⚠️ Campo obligatorio</p>}
          </div>
          <div className="md:col-span-2">
            <label className={labelCls}>Nombre y apellido <span className="text-red-500">*</span></label>
            <input name="nombreApellido" value={formData.nombreApellido} onChange={handleChange} className={inputCls} />
            {!(formData.nombreApellido || '').trim() && <p className="text-sm text-red-600 mt-1">*⚠️ Campo obligatorio</p>}
          </div>
          <div>
            <label className={labelCls}>D.N.I. <span className="text-red-500">*</span></label>
            <input name="dni" value={formData.dni} onChange={handleChange} className={inputCls} />
            {!(formData.dni || '').trim() && <p className="text-sm text-red-600 mt-1">*⚠️ Campo obligatorio</p>}
          </div>
          <div><label className={labelCls}>Fecha de nacimiento</label><input type="date" name="fechaNacimiento" value={formData.fechaNacimiento} onChange={handleChange} className={inputCls} /></div>
          <div><label className={labelCls}>Teléfono</label><input name="telefono" value={formData.telefono} onChange={handleChange} className={inputCls} /></div>
          <div>
            <label className={labelCls}>Dirección {formData.direccionDesdeMapa && <span className="text-blue-600 dark:text-blue-400 font-semibold">* actualizada desde el mapa</span>}</label>
            <input name="direccion" value={formData.direccion} onChange={handleChange} className={inputCls} />
          </div>
          <div><label className={labelCls}>Localidad</label><input name="localidad" value={formData.localidad} onChange={handleChange} className={inputCls} /></div>
          <div><label className={labelCls}>Barrio</label><input name="barrio" value={formData.barrio} onChange={handleChange} className={inputCls} /></div>
          <div><label className={labelCls}>Personas a cargo</label><input type="number" name="personasACargo" value={formData.personasACargo} onChange={handleChange} className={inputCls} /></div>
          <div><label className={labelCls}>¿Hace cuántos años vive en el barrio?</label><input type="number" name="aniosEnBarrio" value={formData.aniosEnBarrio} onChange={handleChange} className={inputCls} /></div>
          <div>
            <label className={labelCls}>La casa es</label>
            <select name="tipoVivienda" value={formData.tipoVivienda} onChange={handleChange} className={inputCls}>
              <option value="">Seleccione...</option>
              <option value="propia">Propia</option>
              <option value="cedida">Cedida</option>
              <option value="alquilada">Alquilada</option>
            </select>
          </div>
        </div>
      </fieldset>

      <fieldset className={fieldsetCls}>
        <legend className={legendCls}>¿Con quiénes vivo?</legend>
        <div className="overflow-x-auto mt-2">
          <table className="w-full text-xs border-collapse">
            <thead>
              <tr className="bg-gray-100 dark:bg-gray-700">
                <th className="border border-gray-300 dark:border-gray-600 p-1.5 text-left">Nombre</th>
                <th className="border border-gray-300 dark:border-gray-600 p-1.5 text-left">Relación</th>
                <th className="border border-gray-300 dark:border-gray-600 p-1.5 text-left">Edad</th>
                <th className="border border-gray-300 dark:border-gray-600 p-1.5 text-left">¿Estudia?</th>
                <th className="border border-gray-300 dark:border-gray-600 p-1.5 text-left">¿Trabaja?</th>
              </tr>
            </thead>
            <tbody>
              {formData.convivientes.map((p, i) => (
                <tr key={i}>
                  <td className="border border-gray-300 dark:border-gray-600 p-1"><input value={p.nombre} onChange={(e) => handleConvivienteChange(i, "nombre", e.target.value)} className="w-full border-none bg-transparent text-sm p-1" /></td>
                  <td className="border border-gray-300 dark:border-gray-600 p-1"><input value={p.relacion} onChange={(e) => handleConvivienteChange(i, "relacion", e.target.value)} className="w-full border-none bg-transparent text-sm p-1" /></td>
                  <td className="border border-gray-300 dark:border-gray-600 p-1"><input type="number" value={p.edad} onChange={(e) => handleConvivienteChange(i, "edad", e.target.value)} className="w-full border-none bg-transparent text-sm p-1" /></td>
                  <td className="border border-gray-300 dark:border-gray-600 p-1"><input value={p.estudia} onChange={(e) => handleConvivienteChange(i, "estudia", e.target.value)} className="w-full border-none bg-transparent text-sm p-1" /></td>
                  <td className="border border-gray-300 dark:border-gray-600 p-1"><input value={p.trabaja} onChange={(e) => handleConvivienteChange(i, "trabaja", e.target.value)} className="w-full border-none bg-transparent text-sm p-1" /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <button type="button" onClick={agregarConviviente} className="mt-2 text-xs text-blue-600 hover:text-blue-800 font-medium">+ Agregar integrante</button>
      </fieldset>

      <h2 className="text-lg font-bold text-gray-900 dark:text-white">ENCUESTA TÉCNICA</h2>

      <fieldset className={fieldsetCls}>
        <legend className={legendCls}>1. Nivel de Criticidad</legend>
        <div className="mt-2 space-y-2">
          <div>
            <label className={labelCls}>Categoría de la vivienda</label>
            <div className="space-y-1">
              {["Precaria/Casilla", "En proceso de consolidación", "Consolidada"].map((opt) => (
                <label key={opt} className="flex items-center gap-2 text-sm">
                  <input type="radio" name="nivelCriticidad" value={opt} checked={formData.nivelCriticidad === opt} onChange={handleChange} />
                  {opt}
                </label>
              ))}
            </div>
          </div>
          <div>
            <label className={labelCls}>Estado general de la vivienda</label>
            <div className="flex gap-4">
              {["Bueno", "Regular", "Malo"].map((opt) => (
                <label key={opt} className="flex items-center gap-2 text-sm">
                  <input type="radio" name="estadoGeneral" value={opt} checked={formData.estadoGeneral === opt} onChange={handleChange} />
                  {opt}
                </label>
              ))}
            </div>
          </div>
          <div>
            <label className={labelCls}>Breve descripción de la mejora</label>
            <textarea name="breveDescripcionMejora" value={formData.breveDescripcionMejora} onChange={handleChange} rows={3} className={inputCls} />
          </div>
        </div>
      </fieldset>

      <fieldset className={fieldsetCls}>
        <legend className={legendCls}>2. ¿Cuál es tu prioridad?</legend>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-2 mt-2">
          {[
            ["piso", "Piso"], ["techo", "Techo"], ["paredes", "Paredes"],
            ["revoques", "Revoques"], ["aislante", "Aislante"], ["instalacionGas", "Inst. Gas"],
            ["instalacionAgua", "Inst. Agua"], ["instalacionLuz", "Inst. Luz"],
            ["instalacionCloacas", "Inst. Cloacas"], ["otros", "Otros"],
          ].map(([name, label]) => (
            <label key={name} className="flex items-center gap-2 text-sm">
              <input type="checkbox" name={name} checked={formData.prioridades[name]} onChange={handleCheckboxChange} />
              {label}
            </label>
          ))}
        </div>
      </fieldset>

      <fieldset className={fieldsetCls}>
        <legend className={legendCls}>Impacto y Presupuesto</legend>
        <div className="mt-2 space-y-3">
          <div>
            <label className={labelCls}>¿En qué mejora mi calidad de vida?</label>
            <textarea name="calidadDeVidaMejora" value={formData.calidadDeVidaMejora} onChange={handleChange} rows={2} className={inputCls} />
          </div>
          <div>
            <label className={labelCls}>¿Qué necesito para realizar la mejora?</label>
            <div className="overflow-x-auto mt-1">
              <table className="w-full text-xs border-collapse">
                <thead>
                  <tr className="bg-gray-100 dark:bg-gray-700">
                    <th className="border border-gray-300 dark:border-gray-600 p-1.5 text-left">Materiales</th>
                    <th className="border border-gray-300 dark:border-gray-600 p-1.5 text-left">Cantidad</th>
                    <th className="border border-gray-300 dark:border-gray-600 p-1.5 text-left">Precio</th>
                  </tr>
                </thead>
                <tbody>
                  {formData.materiales.map((m, i) => (
                    <tr key={i}>
                      <td className="border border-gray-300 dark:border-gray-600 p-1"><input value={m.descripcion} onChange={(e) => handleMaterialChange(i, "descripcion", e.target.value)} className="w-full border-none bg-transparent text-sm p-1" /></td>
                      <td className="border border-gray-300 dark:border-gray-600 p-1"><input value={m.cantidad} onChange={(e) => handleMaterialChange(i, "cantidad", e.target.value)} className="w-full border-none bg-transparent text-sm p-1" /></td>
                      <td className="border border-gray-300 dark:border-gray-600 p-1"><input type="number" value={m.precio} onChange={(e) => handleMaterialChange(i, "precio", e.target.value)} className="w-full border-none bg-transparent text-sm p-1" /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <button type="button" onClick={agregarFilaMaterial} className="mt-2 text-xs text-blue-600 hover:text-blue-800 font-medium">+ Agregar Material</button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div><label className={labelCls}>Mano de Obra (Precio)</label><input type="number" name="manoDeObraPrecio" value={formData.manoDeObraPrecio} onChange={handleChange} className={inputCls} /></div>
            <div><label className={labelCls}>Otro (Precio)</label><input type="number" name="otroGastoPrecio" value={formData.otroGastoPrecio} onChange={handleChange} className={inputCls} /></div>
          </div>
        </div>
      </fieldset>

      <fieldset className={fieldsetCls}>
        <legend className={legendCls}>Datos del Crédito Solicitado</legend>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-2">
          <div><label className={labelCls}>¿Qué monto de crédito va a solicitar?</label><input type="number" name="montoCredito" value={formData.montoCredito} onChange={handleChange} className={inputCls} /></div>
          <div><label className={labelCls}>Forma de pago</label><input name="formaPago" value={formData.formaPago} onChange={handleChange} className={inputCls} /></div>
          <div><label className={labelCls}>N° de cuotas</label><input type="number" name="nroCuotas" value={formData.nroCuotas} onChange={handleChange} className={inputCls} /></div>
          <div><label className={labelCls}>Monto de las cuotas</label><input type="number" name="montoCuotas" value={formData.montoCuotas} onChange={handleChange} className={inputCls} /></div>
          <div><label className={labelCls}>Mes de inicio</label><select name="mesInicio" value={formData.mesInicio} onChange={handleChange} className={inputCls}><option value="">Seleccione...</option><option value="1">Enero</option><option value="2">Febrero</option><option value="3">Marzo</option><option value="4">Abril</option><option value="5">Mayo</option><option value="6">Junio</option><option value="7">Julio</option><option value="8">Agosto</option><option value="9">Septiembre</option><option value="10">Octubre</option><option value="11">Noviembre</option><option value="12">Diciembre</option></select></div>
          <div><label className={labelCls}>Frecuencia de pago</label><input name="frecuenciaPago" value={formData.frecuenciaPago} onChange={handleChange} className={inputCls} /></div>
        </div>
        <div className="mt-3">
          <label className={labelCls}>Garantía (Garantes del proyecto)</label>
          <textarea name="garantiaGarantes" value={formData.garantiaGarantes} onChange={handleChange} rows={2} className={inputCls} />
        </div>
      </fieldset>

      <div className="flex justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
        <button type="button" onClick={onCancel} className={btnSecondaryCls}>Cancelar</button>
        <button
          type="button"
          onClick={handleValidar}
          disabled={!obligatoriosCompletos}
          className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${obligatoriosCompletos ? 'text-gray-700 dark:text-gray-200 bg-gray-200 dark:bg-gray-600 hover:bg-gray-300 dark:hover:bg-gray-500' : 'text-gray-400 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 cursor-not-allowed'}`}
        >
          Validar y salir
        </button>
        {showUbicarButton && (
          <button type="submit" className={btnCls}>{saveLabel || 'Ir a mapa'}</button>
        )}
      </div>
    </form>
  );
};

export default EncuestaSocioambiental;
